import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';
import { CodeTitle, Code } from './card.styles';
import { CodeLoader } from './codeLoader';
import messages from './card.messages';
import BookingCard from '../../../../shared/components/bookingCard/bookingCard.container';
import { renderWhenTrueOtherwise } from '../../../../shared/utils/rendering';

export class Card extends PureComponent {
  static propTypes = {
    renderImageOnce: PropTypes.bool,
    bookingCode: PropTypes.string,
    isKioskMode: PropTypes.bool,
    intl: PropTypes.object,
    signOut: PropTypes.func,
  };

  static defaultProps = {
    renderImageOnce: false,
  };

  componentDidMount() {
    const { bookingCode, signOut, isKioskMode } = this.props;
    if (bookingCode && isKioskMode) {
      signOut();
    }
  }

  componentDidUpdate(prevProps) {
    const { bookingCode, signOut, isKioskMode } = this.props;
    if (prevProps.bookingCode === null && bookingCode !== null && isKioskMode) {
      signOut();
    }
  }

  render() {
    const { bookingCode, intl } = this.props;

    return (
      <BookingCard renderImageOnce={this.props.renderImageOnce}>
        <CodeTitle>{intl.formatMessage(messages.code)}</CodeTitle>
        {renderWhenTrueOtherwise(() => <CodeLoader />, () => <Code>{bookingCode}</Code>)(isNil(bookingCode))}
      </BookingCard>
    );
  }
}
